module.exports = __webpack_public_path__ + "img/Bg.39fff4e2.png";